export enum eventCategory {
    INDEX = 'siteIndex',
    LANDING = 'landing',
    MARKETING = 'marketingEvents',
    PREREG = 'preregEvents',
    WEBGL_CLIENT_EVENTS = 'webglClientEvents',
    WIPE = 'wipeEvents',
}

export enum gameEvents {
    CAPITOL_LEVELING = 'CAPITOL_',
    CLICKS_100 = '100_CLICKS',
    HERO_UPGRADE = 'HERO_UPGRADE',
    HERO_LEVELING = 'HERO_',
    MARCHES_9 = 'MARCHES_9',
    MONSTER_LVL_5 = 'MONSTER_LVL_5',
    TUTOR_FINISH = 'tutor_finish',
    UNITS_TRAIN_SILVER_10000 = 'UNITS_TRAIN_SILVER_10000',
    VALOR_MONSTER_1000_PER_MARCH = 'VALOR_MONSTER_1000_PER_MARCH',
    VALOR_MONSTER_1000 = 'VALOR_MONSTER_1000',
    WEB_GUEST_HAS_SWITCHED_GP = 'webGuestHasSwitchedGameProgress',
}

export enum commerceEvents {
    GA_PURCHASE = 'Purchase',
    FIRST_PAYMENT = '1stpayment',
    SUCCESS_BUY = 'successBuy',
    INITIATE_CHECKOUT = 'InitiateCheckout',
    PAYMENT_SUCCESS_FINISHED = 'PaymentSuccessFinished'
}

export enum systemEvents {
    CLICK_SOCIAL_ICON = 'clickSocialIcon',
    CLOSE_BETA_POPUP = 'closeBetaPopupClick',
    CHECK_CONSENT = 'checkConsent',
    CHECK_POLICY = 'checkPolicy',
    DOWNLOAD_BETA = 'downloadBetaClick',
    DOWNLOAD_CLIENT = 'DOWNLOAD_CLIENT',
    EMAIL_REG_SUCCESS = 'emailRegistrationSuccess',
    ENTER_EMAIL = 'enterEmail',
    ENTER_PASSWORD = 'enterPass',
    INSTALL = 'INSTALL',
    INGAME_INSTALL = 'INGAME_INSTALL',
    IS_LANDING_REG = 'isLandingRegistration',
    LANDING = 'landing',
    OPEN_BETA_POPUP = 'openBetaPopupClick',
    PREREG_CONFIRM = 'preregConfirm',
    PREREG_COMPLETE = 'preregComplete',
    REGISTRATION_COMPLETE = 'REGISTRATION_COMPLETE',
    SERVER_LOGIN = 'serverLogin',
    SITE_SOCIAL_REG_OK = 'siteSocialRegistrationSuccess',
    SUBMIT = 'submitPress',
    WIPED = 'wiped',
    CLICK_SOCIAL_LOGIN_GOOGLE = 'clickSocialGoogle',
    CLICK_SOCIAL_LOGIN_EMAIL = 'clickSocialEmail',
    CLICK_SOCIAL_LOGIN_FACEBOOK = 'clickSocialFacebook',
    REGISTRATION = 'registration'
}

export enum webglEvents {
    FAILED_INDEXED_DB = 'failIndexedDB',
    WEBGL_FINISH_LOADING = 'webglFinishLoading',
    WEBGL_START_LOADING = 'webglStartLoading',
}
